import { LearningPosition } from '~/aioracle/types/learning-context.types'

/** Projects a theory article onto the position the Oracle slice stores. Uses `path`, never `key` /
 *  `sharedLanguageKey`: those are cross-locale, so two locales would clear each other's context. */
export const buildEncyclopediaContext = ({ path }: { path?: string }): LearningPosition | undefined =>
  path ? { contextId: path, source: 'encyclopedia', articlePath: path } : undefined
